import React from 'react'
import styles from './Followers.module.css'

const Followers = () => {
  return (
    <div>
      coming soon......! :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :) :
    </div>
  )
}

export default Followers
